import { createAction } from '@reduxjs/toolkit';
/**
 * set isPublicLink into the session state.
 * iPublic indicates whether the user is viewing a collection via a
 * public view instead of as logged in user (publicly shared collections
 * have '/public/' shared prefix)
 */
export var setIsPublicLink = createAction('session/setIsPublicLink');
export var setIsMobile = createAction('session/setIsMobile');
export var reviewInvites = createAction('session/invitesReviewed');
